import { render, staticRenderFns } from "./ShippingHeaderAdd.vue?vue&type=template&id=1f3ecf82"
import script from "./ShippingHeaderAdd.vue?vue&type=script&lang=js"
export * from "./ShippingHeaderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports